import { showGrade } from "../../../utils/textUtils";

const GradeIncreasePreviewModal = ({ students, onConfirm, onCancel }) => {
  const styles = {
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.9)",
      color: "#000",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 2000,
    },
    modalContent: {
      backgroundColor: "#fff",
      borderRadius: "12px",
      width: "90vw",
      maxWidth: "600px",
      maxHeight: "80vh",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    modalHeader: {
      padding: "20px",
      borderBottom: "1px solid #EBEBEB",
    },
    title: {
      fontSize: "18px",
      fontWeight: "bold",
      marginBottom: "8px",
    },
    subtitle: {
      fontSize: "14px",
      color: "#737373",
    },
    studentListContainer: {
      flex: 1,
      overflowY: "auto",
      padding: "20px",
      maxHeight: "50vh",
    },
    studentRow: {
      display: "flex",
      justifyContent: "space-between",
      padding: "12px 16px",
      borderRadius: "4px",
    },
    studentName: {
      fontWeight: "bold",
    },
    gradeTransition: {
      fontSize: "14px",
    },
    modalFooter: {
      padding: "20px",
      borderTop: "1px solid #EBEBEB",
      display: "flex",
      gap: "10px",
      justifyContent: "flex-end",
    },
    confirmButton: {
      backgroundColor: "#438CFB",
      color: "#fff",
      border: "none",
      padding: "8px 24px",
      cursor: "pointer",
      borderRadius: "4px",
      fontSize: "14px",
    },
    cancelButton: {
      backgroundColor: "#EBEBEB",
      color: "#737373",
      border: "none",
      padding: "8px 24px",
      cursor: "pointer",
      borderRadius: "4px",
      fontSize: "14px",
    },
  };

  return (
    <div style={styles.modalOverlay} onClick={onCancel}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div style={styles.modalHeader}>
          <div style={styles.title}>학년 일괄 증가 미리보기</div>
          <div style={styles.subtitle}>총 {students.length}명의 학생</div>
        </div>

        <div style={styles.studentListContainer}>
          {students.map((student, index) => (
            <div
              key={student.id}
              style={{
                ...styles.studentRow,
                backgroundColor: index % 2 === 0 ? "#FFF" : "#F6F8FA",
              }}
            >
              <span style={styles.studentName}>{student.name}</span>
              <span style={styles.gradeTransition}>
                {showGrade(student.grade)} → {showGrade(student.grade + 1)}
              </span>
            </div>
          ))}
        </div>

        <div style={styles.modalFooter}>
          <button style={styles.cancelButton} onClick={onCancel}>
            취소
          </button>
          <button style={styles.confirmButton} onClick={onConfirm}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default GradeIncreasePreviewModal;
